import RoutinesIcon from "../common/icons/RoutinesIcon";
import SettingsIcon from "../common/icons/more/SettingsIcon";
import UsersIcon from "../common/icons/more/UsersIcon";
import ImpersonateIcon from "../common/icons/more/ImpersonateIcon";
import ClearCacheIcon from "../common/icons/more/ClearCacheIcon";
import InviteIcon from "../common/icons/more/InviteIcon";
import LogoutIcon from "../common/icons/more/LogoutIcon";
import GuidesIcon from "../common/icons/more/GuidesIcon";
import ReportsIcon from "../common/ActionsMenuButton/icons/ReportsIcon";
import IntegrationIcons from "../common/icons/integrations/index";
import appPages from "../../../appPages";
import RepeatIcon from "../common/icons/more/RepeatIcon";
import PaymentsIcon from "../common/icons/more/PaymentsIcon";
import MoreCalendarIcon from "../common/icons/MoreCalendarIcon";
import AppConfig from "../../../config/AppConfig";

export default [
  {
    id: 1,
    name: "Learn",
    children: [
      {
        id: 101,
        name: "Repeat Onboarding",
        iconTag: RepeatIcon,
        page: appPages.onboardingPage,
        page_args: {},
      },
      /* {
        id: 101,
        name: "Routines",
        iconTag: RoutinesIcon,
        page: "rn:routines",
        page_args: {},
      }, */
      {
        id: 102,
        name: "Get Started",
        iconTag: GuidesIcon,
        page: "rn:get_started",
        page_args: {},
      },
      {
        id: 103,
        name: "Knowledge Resources",
        iconTag: GuidesIcon,
        page: "rn:knowledge_base",
        page_args: {},
      },
      {
        id: 104,
        name: "Schedule Guide Call",
        iconTag: MoreCalendarIcon,
        isScheduleGuideCall: true,
      },
      /* {
        id: 104,
        name: "Last Week",
        iconTag: RoutinesIcon,
        page: "rn:onboarding_template",
        page_args: {},
      }, */
    ],
  },
  {
    id: 2,
    name: "Settings",
    children: [
      {
        id: 201,
        name: "Preferences",
        iconTag: SettingsIcon,
        page: "settings",
      },
      {
        id: 202,
        name: "Integrations",
        iconTag: IntegrationIcons.IntegrationsIconGradient,
        page: "integrations",
      },
    ],
  },
  {
    id: 4,
    name: "More",
    children: [
      {
        id: 401,
        name: "Aggregated Reports",
        iconTag: ReportsIcon,
        page: "received_aggregated_reports",
      },
      {
        id: 402,
        isGuideOption: true,
        name: "Update Integrations",
        iconTag: ClearCacheIcon,
        action: "update_integrations",
        page: "home",
      },
      {
        id: 403,
        name: "Invite Friends",
        iconTag: InviteIcon,
        page: "invite_friends",
      },
      {
        id: 404,
        name: "Payment Settings",
        iconTag: PaymentsIcon,
        page: appPages.payments,
      },
      {
        id: 405,
        name: "Logout",
        iconTag: LogoutIcon,
        action: "logout",
      },
    ],
  },
  {
    id: 3,
    name: "Admin Tools",
    isGuideOption: true,
    children: [
      {
        id: 301,
        isGuideOption: true,
        name: "Enabled users",
        iconTag: UsersIcon,
        page: "enabled_users",
      },
      {
        id: 302,
        isGuideOption: true,
        name: "Impersonate",
        iconTag: ImpersonateIcon,
        page: "impersonate",
      },
      {
        id: 303,
        isGuideOption: true,
        name: "Clear Caches",
        iconTag: ClearCacheIcon,
        action: "clear_caches",
        page: "home",
      },
      /*{
        id: 304,
        name: "Guides",
        icon: require("../../../assets/more/Guides.png"),
        page: "rn:guides",
      },*/
      /* {
        id: 305,
        name: "Animation",
        iconTag: AnimationIcon,
        page: "onboarding_img",
      }, */
      /*{
        id: 306,
        name: "Recent Entries",
        icon: require("../../../assets/more/RecentEntries.png"),
        page: "recent_entries",
        actionType: "requestpage",
      },
      {
        id: 307,
        name: "Average Week (Real Data)",
        icon: require("../../../assets/more/AverageWeek.png"),
        page: "onboarding_template",
      },*/
      {
        id: 308,
        isGuideOption: true,
        name: "Testing",
        iconTag: SettingsIcon,
        page: "testing",
      },
      {
        id: 309,
        isGuideOption: true,
        name: "Dashboard",
        iconTag: RoutinesIcon,
        page: "dashboard",
      },
    ],
  },
];
